export const featureKey = 'genesysCloudMessageConversations';
